//
//
//
//
//
//
//
export default {
  props: {
    type: {
      type: String,
      required: true,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: 'rgb(0, 255, 246)'
    }
  },

  /* eslint-disable */
  computed: {
    render: function render() {
      var _this = this;

      return function () {
        return {
          component: import("./components/".concat(_this.type))
        };
      };
    }
  }
};